export const CREATE_EMPLOYEE_STATUS = {
  CREATED: 'CREATED',
  ALREADY_EXISTS: 'ALREADY_EXISTS',
  ERROR: 'ERROR',
} as const;
